import { axios } from '../../services/axios';

const getOperatorPlatformServiceProfile = async ({ scope }) => {
    const result = await axios.get(`/ServiceProfile/OperatorPlatform/${scope}`);
    return result;
};
export default getOperatorPlatformServiceProfile;
